<g transform="translate(-11, 0)">
  <circle cx="11" cy="11" r="11" class="fill-emerald-500" />
  <g transform="translate(3, 3)">
    <path
      d="M18.137 38.6 4.3 24.763l3.794-3.794 10.043 10.043 21.369-21.37 3.794 3.795L18.137 38.6z"
      class="fill-white scale-[0.3333333333333333]"
    />
  </g>
</g>
